"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importStar(require("react"));
const videoStyles_1 = require("../../styling/videoStyles");
// Styles
const styles_1 = tslib_1.__importDefault(require("./styles"));
const MediaWrapper = (0, react_1.forwardRef)(({ classes, ...props }, ref) => {
    const { children, isFullscreen } = props;
    const mergedClasses = (0, videoStyles_1.useStyles)({ source: classes !== null && classes !== void 0 ? classes : {}, target: styles_1.default }, "mediaWrapper");
    return (react_1.default.createElement("div", { className: `
        ${mergedClasses.root ? mergedClasses.root : ""}
        ${isFullscreen ? "video-fullscreen-mode lv-fullscreen-mode" : ""}
      `, ref: ref }, children));
});
exports.default = MediaWrapper;
//# sourceMappingURL=index.js.map